function safeJsonParse(input, fallback = "{}") {
    if (typeof input !== "string") {
        return fallback;
    }
    input = input.trim();

    if (!input.startsWith("{") && !input.startsWith("[")) {
        return fallback;
    }

    try {
        return JSON.parse(input);
    } catch (err) {
        //if we can't parse the json return the fallback.
        return fallback;
    }
}

function normalizeChoices(input) {
    if (!input) {
        return null;
    }

    if (typeof input === "object") {
        return input;
    }

    if (typeof input !== "string") {
        return null;
    }

    const trimmedInput = input.trim();
    if (!trimmedInput) {
        return null;
    }

    try {
        const parsedChoices = JSON.parse(trimmedInput);
        return typeof parsedChoices === "object" && parsedChoices !== null ? parsedChoices : null;
    } catch (_error) {
        return null;
    }
}
const parseDataFromServer = function(result, category) {
    let newState = {
        loading: false,
        name: result.name,
        quantity: this.props?.initialQuantity > 1 ? this.props.initialQuantity : (window?.editLineQty > 1 ? window?.editLineQty : 1),
        imageSmall: result.imageURL ? result.imageURL : result.imageURL_banner,
        imageLarge: result.imageURL_banner ? result.imageURL_banner : result.imageURL,
        maxToppings: result.max_toppings,
        itemNavigationID: result.id,
        description: result.description,
        addonGroups: result.addon_groups,
        categoryName: category && category.name ? category.name : 'None',
        categoryID: category && category.id ? category.id : 0
    };
    // Create special modifier to represent item navigations
    let itemNavigationModifier = {
        name: result.name,
        matrixWeight: result.matrix_weight,
        priceLevels: safeJsonParse(result.level_price)
    };
    // Set it to the magic number 0 so it doesn't rob a legitimate modifier of its ID
    let modifiers = {
        0: itemNavigationModifier
    };
    let includedModifiers = {};
    let styles = [];
    let options = [];
    let modificationGroups = result.modification_groups;
    modificationGroups.forEach( (val, ind, arr) => {
        // For each modification group, start by getting it's modifiers
        let modifications = val.modifications;
        let modificationsArray = [];
        modifications.forEach( (modVal, modInd, modArr) => {
            //for each modifier, selectively grab the relevant properties
            let modKey = modVal.id;
            let modName = modVal.name;
            let priceLevels = modVal.level_price;
            if(typeof(priceLevels) === 'string') {
                priceLevels = JSON.parse(priceLevels);
            }
            let includedQuantity = modVal.included_quantity;
            // Add this key to the array for the parent group, so it will display,
            // but only if not included
            if(includedQuantity < 1) {
                modificationsArray.push(modKey);
            }
            let maxQuantity = modVal.maximum_quantity;
            let showDouble = modVal.show_double_toppings > 0;
            let showHalf = modVal.show_half_toppings > 0;
            let matrixWeight = modVal.matrix_weight;
            let selectedQuantity = modVal.selected_quantity;
            let modMenuId = modVal.menu_id;
            // Handle includedQuantity special case
            if(includedQuantity > 0) {
                includedModifiers[modKey] = {
                    /**
                     * TODO: Address includedPortion use case
                     */
                    portion: 'whole',
                    quantity: includedQuantity,
                    priceLevels: priceLevels,
                    matrixWeight: matrixWeight
                };
            }
            // Add the modifier to the base modifier KVS
            modifiers[modKey] = {
                name: modName,
                priceLevels: priceLevels,
                includedQuantity: includedQuantity,
                maxQuantity: maxQuantity,
                showDouble: showDouble,
                showHalf: showHalf,
                matrixWeight: matrixWeight,
                selectedQuantity: selectedQuantity,
                menuId: modMenuId
            };
        });
        // Now to handle breaking the actual modificationGroups into styles and options
        // Assuming includedModifiers was already handled by the modifications.forEach
        let isTopping = val.option_type === 'topping';
        let isRadio = val.control_type === 'radio';
        // Since the contents of styles and options look the same, declare it regardless of how we categorize this group
        let groupObject = {
            name: val.name,
            minRequired: 0, //This was originally in the spec, but has been removed in the server side response
            maxAllowed: (val.max_selection > 0 ? val.max_selection : 0), //Was originally specced as 0 = ∞, but server sends -1 = ∞
            modifiers: modificationsArray, // As we cycle through the groups, we push the modifier key for each item to this array
            controlType: val.control_type,
            isTopping: isTopping,
            isRadio: isRadio
        };
        if(groupObject.isRadio) {
            // This is a radio group. Push it to styles
            styles.push(groupObject);
        }else {
            // This is not a radio group, push it to options
            options.push(groupObject);
        }
    });
    // Now we've parsed all of our modifiers for all of our modification groups,
    // and they're ready to be attached to newState
    newState.modifiers = modifiers;
    newState.includedModifiers = includedModifiers;
    newState.options = options;
    newState.styles = styles;

    
    //Now before we can load our choices, we have to load our main Item selections
    let mainItemGroupObject = result.item_group;
    let itemGroup = {
        displayName: mainItemGroupObject.name
    };
    let sanitizeMatrix = function(matrix) {
        if(typeof(matrix) === 'string') {
            return JSON.parse(matrix);
        }else {
            return matrix;
        }
    };
    let itemGroupOptions = mainItemGroupObject.items.map( (val, ind, arr) => {
        return {
            id: val.id,
            name: val.name,
            level: val.menu_level,
            usesMatrixPricing: val.is_matrix > 0,
            basePrice: val.price,
            matrixPrices: val.matrix_price ? sanitizeMatrix(val.matrix_price) : { // Used in matrix level calculations
                0: 0.00,
                1: 0.00,
                2: 0.00,
                3: 0.00,
                4: 0.00,
                5: 0.00,
                6: 0.00,
                7: 0.00,
                8: 0.00,
                9: 0.00,
                10: 0.00
            }
        };
    });
    itemGroup.items = itemGroupOptions;
    //Now itemGroup is assembled, we attach it to newState
    newState.itemGroup = itemGroup;
    // Now we've loaded everything into the payload for setState, with the exception of our choices
    // We want to carry forward simply the default choices
    let chosenIncludedModifiers = {};
    for (const incKey in includedModifiers) {
        if (includedModifiers.hasOwnProperty(incKey)) {
            const incMod = includedModifiers[incKey];
            chosenIncludedModifiers[incKey] = {
                portion: incMod.portion,
                quantity: incMod.quantity,
                size: 'normal'
            };
        }
    }
    let chosenModifiers = {};
    for (const availKey in modifiers) {
        if (modifiers.hasOwnProperty(availKey)) {
            const mod = modifiers[availKey];
            if(availKey === '0') {
                chosenModifiers[availKey] = {
                    quantity: 1,
                    portion: 'whole',
                    size: 'normal'
                };
            }else {
                chosenModifiers[availKey] = {
                    quantity: mod.selectedQuantity ? mod.selectedQuantity : 0,
                    portion: 'whole',
                    size: 'normal'
                };
            }
        }
    }
    const editItemChoices = normalizeChoices(this.props?.initialChoices) || normalizeChoices(window.editItemChoices);
    if(editItemChoices) {
        newState.choices = editItemChoices;
    }else {
        newState.choices = {
            includedModifiers: chosenIncludedModifiers,
            item: 0, // First item in the array by default
            modifiers: chosenModifiers,
            addOns: {}
        };
    }
    

    //This validation needs to occur after choices have been set, in order to allow pre-selected radios
    if(styles.length > 0) {
        //Set to false
        newState.isValid = false;
        //But still double check every radio group
        let noStyleHasFailed = true;
        styles.forEach( (val, ind, arr) => {
            let modifiers = val.modifiers;
            //Assume this style is invalid
            let styleValidity = false;
            modifiers.forEach( (modVal, modInd, modArr) => {
                const chosenQuantity = newState?.choices?.modifiers?.[modVal]?.quantity ?? 0;
                if(chosenQuantity > 0) {
                    //If any of these are chosen, the style is valid
                    styleValidity = true;
                }
            });
            if(!styleValidity) {
                //If this style is invalid, the whole block is invalid, so we set noStyleHasFailed to false
                noStyleHasFailed = false;
            }
        });
        if(noStyleHasFailed) {
            newState.isValid = true;
        }
    }
    // Now newState actually represents the newly loaded state
    
    this.setState(newState);
};
export default parseDataFromServer;
